import { type ComponentChildren } from "preact";

import { Header } from "@/components/layout/header";

import { useSearchParams } from "@/lib/hooks/use-search-params";

interface CheckoutLayoutProps {
  children: ComponentChildren;
}

export function CheckoutLayout({ children }: CheckoutLayoutProps) {
  const { get } = useSearchParams();
  const isMobileApp = get<boolean>("isMobileApp");
  return (
    <div className="bg-background text-foreground flex min-h-screen flex-col">
      {!isMobileApp && <Header />}
      <main className="flex-grow">{children}</main>
    </div>
  );
}
